<script setup>
defineProps({
  plans: { type: Array, default: () => [] },
  modelValue: { type: String, default: 'starter' },
});

const emit = defineEmits(['update:modelValue']);

const priceLabel = plan => {
  if (plan.contact_sales) return 'Custom';
  if (!plan.price_cents) return 'Free';
  return `$${plan.price_cents / 100}/mo`;
};
</script>

<template>
  <div class="grid grid-cols-2 gap-2 mb-4" :class="{ hidden: !plans.length }">
    <button
      v-for="plan in plans"
      :key="plan.key"
      type="button"
      class="text-left px-3 py-2 rounded-lg border transition-colors"
      :class="
        modelValue === plan.key
          ? 'border-n-brand bg-n-alpha-1 dark:bg-n-solid-3'
          : 'border-n-weak hover:border-n-slate-6'
      "
      @click="emit('update:modelValue', plan.key)"
    >
      <div class="text-sm font-medium text-n-slate-12">{{ plan.name }}</div>
      <div class="text-xs text-n-slate-11">{{ priceLabel(plan) }}</div>
    </button>
  </div>
</template>
